var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor send-transcript" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Email")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Type your email or use attribute",
              "show-attributes": true,
              "show-emoji": false,
              "max-character-count": 200,
            },
            model: {
              value: _vm.clone.email,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "email", $$v)
              },
              expression: "clone.email",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }